




































































































import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import { userLogin } from "@/utils/auth";
import { namespace } from "vuex-class";

/**
 * Mixins
 */

/**
 * Components
 */

/**
 * API
 */

import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";

/**
 * Types
 */

/**
 * VueX Modules
 */
const profileModule = namespace("profile");



@Component
export default class LoginPage extends Vue {
	/** Attributs */
	isLoading = false;
	
	/** VueX Modules */
	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;

	/** Méthodes */
	async handleLogin() {
		this.isLoading = true;
		try {
			await userLogin(this.$router);
		}
		catch (err) {
			this.handleAPIError(err);
			this.isLoading = false;
		}

	}
}
